// extracted by mini-css-extract-plugin
export default {"recommendationSection":"Recommendation_recommendationSection__wpa88"};